module.exports = __webpack_public_path__ + "img/thumbnail_BlackRhinoceros_m_normal.1b51731a.png";